import { StoreResponse, StoreWithDistanceResponse } from './store.response';
import { StoreState, StoreWithDistanceState } from './store.state';

/** Pure wire → state mappers for the store endpoints (no date fields). */

export function mapStoreResponse(response: StoreResponse): StoreState {
  return { ...response };
}

export function mapStoreWithDistanceResponse(response: StoreWithDistanceResponse): StoreWithDistanceState {
  return { ...response };
}
